import { useQuery, UseQueryResult } from '@tanstack/react-query'
import { ApiMetaDataDTO, SupplierPreferenceRuleDTO } from 'declarations'
import { toast } from 'react-toastify'

import { client } from 'services/helpers/apiConfig'

type ApiResponseDTO = {
  code: number
  data: SupplierPreferenceRuleDTO
  api_metadata: ApiMetaDataDTO
}

const useSprTestQuery = (
  uuid: string,
  partNumber: string
): UseQueryResult<SupplierPreferenceRuleDTO> => {
  return useQuery({
    queryKey: ['spr', 'test', uuid, partNumber],
    queryFn: async () => {
      try {
        const res = await client.get<ApiResponseDTO>(
          `supplier_preference_rules/test/${uuid}?part_number=${partNumber}`
        )

        return res.data.data
      } catch (err) {
        toast.error(err.response.data.message)
        throw err.response.data
      }
    },
    enabled: false,
  })
}

export { useSprTestQuery }
